import link from "@/scripts/host.js";
import loggedIn from '@/scripts/logged.js';



export default {
  name: "ChangePassword",
  props: ["close"],
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      repeatPassword: '',
      invalid: false,
      showErrorInfo: null
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },
    checkPassword() {
      const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;
      return re.test(this.newPassword);
    },
    async changePassword() {
      let token = await loggedIn();

      if(this.newPassword === this.repeatPassword ){
        if(this.checkPassword()){
          this.showErrorInfo = null;
          this.axios({
            method: 'post',
            url: `${link.hostLink}Account/ChangePassword`,
            headers: {authorization: `bearer ${token}`},

            data: {'oldPassword':this.oldPassword, 'newPassword':this.newPassword},
            })
            .then(() => {
                this.$store.dispatch('setGenericModalText', 'Hasło zostało pomyślnie zmienione.');

                this.$store.dispatch('setModalType', 'genericModal');
            })
            .catch((error)=> {
              this.showErrorInfo=error.response.data.exception;
            });
        } else {
          this.showErrorInfo = "Hasło musi zawierać minimum 6 znaków, w tym min. 1 dużą literę i 1 cyfrę.";
        }
      } else {
        this.showErrorInfo = "Nowe hasło nie jest takie samo w obu przypadkach";
      }
    }
  },
  mounted() {}
}
